import {z} from 'zod';
import {Role} from '../../user';
import {usernameValidator} from './username';
import {tm} from '../../../i18n';

export const createUserValidator = z.object({
    username: usernameValidator,
    email: z.string().email({message: tm('registerPage.errorMessages.email')}),
    password: z
        .string()
        .min(7, {message: tm('registerPage.errorMessages.passwordShort')})
        .max(24, {message: tm('registerPage.errorMessages.passwordLong')}),
    passwordExpirationTime: z.number().min(1, {message: tm('registerPage.errorMessages.passwordExpirationTime')}),
    roles: z.array(z.nativeEnum(Role)),
});
